import { useEffect } from 'react';

export default function RelatedModal({ piece, onClose }) {
  useEffect(() => {
    if (!piece) return;

    const handleEsc = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleEsc);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [piece, onClose]);

  if (!piece) return null;

  return (
    <div
      className="fixed inset-0 z-[200] flex items-center justify-center bg-black/85 backdrop-blur-md animate-overlayFadeIn px-6"
      onClick={onClose}>
      <div
        className="relative w-full max-w-xl md:max-w-2xl animate-modalFadeIn"
        onClick={(e) => e.stopPropagation()}>

        {/* Bouton fermer — au-dessus, à droite */}
        <button
          onClick={onClose}
          aria-label="Fermer"
          className="absolute -top-12 right-0 z-10 flex items-center gap-3 text-white/60 hover:text-white transition-colors group">
          <span className="text-[11px] tracking-[0.25em] uppercase">Fermer</span>
          <span className="w-8 h-px bg-current transition-all duration-300 group-hover:w-12" />
        </button>

        {/* Carte */}
        <div className="bg-black/40 backdrop-blur-sm border border-white/10 overflow-hidden shadow-2xl">
          {piece.img && (
            <div className="relative w-full aspect-[4/5] md:aspect-[5/4] overflow-hidden">
              <img src={piece.img} alt={piece.name}
                className="w-full h-full object-cover" />
              <div className="absolute inset-0" style={{ boxShadow: 'inset 0 0 120px 40px rgba(0,0,0,0.15)' }} />
            </div>
          )}

          <div className="px-8 md:px-12 py-8 md:py-10 text-center border-t border-white/5">
            {piece.stone && (
              <p className="text-[10px] tracking-[0.35em] uppercase text-white/35 mb-3">
                {piece.stone}
              </p>
            )}
            <p className="font-serif text-2xl md:text-3xl text-white font-light tracking-wide leading-snug">
              {piece.name || <span className="italic text-white/40">Sans titre</span>}
            </p>
            <div className="w-10 h-px bg-white/20 mx-auto mt-6" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes overlayFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes modalFadeIn {
          from { opacity: 0; transform: translateY(20px) scale(0.97); }
          to { opacity: 1; transform: translateY(0) scale(1); }
        }
        .animate-overlayFadeIn { animation: overlayFadeIn 0.4s ease-out forwards; }
        .animate-modalFadeIn { animation: modalFadeIn 0.5s cubic-bezier(0.22, 1, 0.36, 1) forwards; }
      `}</style>
    </div>
  );
}
